import cx from 'clsx';
import React, { useState } from 'react';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Divider from '@material-ui/core/Divider';
import CloseIcon from '@material-ui/icons/Close';
import Accordion from '@material-ui/core/Accordion';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import ListItem from '@material-ui/core/ListItem';
import { Company } from '../../Footer/Company';
import { ClientNames } from '../../../models';
import { Links } from '../../../components/links';
import { ImgWithFallback } from '../../../components/ImgWithFallback';
import { LANGUAGES, MAIN_TOOLS, MINI_TOOLS, RESOURCES, SOCIAL_MEDIAS } from '../../../models/constants';
import { useStyles } from '../../../models/styles/mobile';
const LANGUAGE_MENU = [
    {
        label: 'language',
        children: LANGUAGES.map((e) => ({
            label: e.name,
            url: e.url,
            code: e.code
        }))
    }
];
const DrawerContent = ({ isCheckoutPage, currentLanguageLabel, handleDrawerToggle, onAction, Link, isLogin, intl, user, changeLang, additionalMenu, profile }) => {
    var _a, _b, _c;
    const classes = useStyles();
    const { subscription, is_multiseat: isMultiSeat } = user || {};
    const { sub_free_plan: isSubFreePlan } = subscription || {};
    const [selectedItem, setSelectedItem] = useState('');
    const [expanded, setExpanded] = useState(false);
    const handleChange = (panel) => (_event, isExpanded) => setExpanded(isExpanded ? panel : false);
    const handleSelectItem = (item) => {
        if (item !== selectedItem)
            return setSelectedItem(item);
        setSelectedItem('');
    };
    const defaultMenu = [
        {
            label: intl === null || intl === void 0 ? void 0 : intl.formatMessage({ id: 'create', defaultMessage: 'Create' }),
            children: MAIN_TOOLS.slice(1).map((e) => ({
                label: e.title,
                url: [ClientNames.mockupmaker].includes(e.name)
                    ? e.url
                    : isLogin
                        ? `${e.url}/start`
                        : e.url,
                external: isLogin
            }))
        },
        {
            label: intl === null || intl === void 0 ? void 0 : intl.formatMessage({ id: 'tools', defaultMessage: 'Tools' }),
            children: MINI_TOOLS.map((e) => ({
                label: e.name,
                url: e.url,
                external: e.outside,
                target: e.target
            }))
        },
        {
            label: intl === null || intl === void 0 ? void 0 : intl.formatMessage({
                id: 'resource',
                defaultMessage: 'Resources'
            }),
            children: RESOURCES.map((e) => ({
                label: e.name,
                url: e.url,
                external: e.outside,
                target: e.target
            }))
        }
    ].filter(Boolean);
    const dashboardWithoutChildren = [
        {
            label: intl === null || intl === void 0 ? void 0 : intl.formatMessage({
                id: 'dashboard',
                defaultMessage: 'Dashboard'
            }),
            url: '/user/dashboard'
        },
        ...additionalMenu === null || additionalMenu === void 0 ? void 0 : additionalMenu.map((menu) => ({
            label: menu.linkName,
            url: menu.href,
            callback: menu.callback
        })),
        {
            label: intl === null || intl === void 0 ? void 0 : intl.formatMessage({
                id: 'brand_kit',
                defaultMessage: 'Brand Kit'
            }),
            url: '/user/brand-kit'
        }
    ];
    const dashboardMenu = [
        {
            label: intl === null || intl === void 0 ? void 0 : intl.formatMessage({
                id: 'my_projects',
                defaultMessage: 'My Projects'
            }),
            children: [
                {
                    label: 'Audios',
                    url: `/ai-audio/start/history`,
                    target: '_blank',
                    rel: 'noreferrer noopener',
                    external: true
                },
                {
                    label: 'Chats',
                    url: `/ai-chat/start`,
                    target: '_blank',
                    rel: 'noreferrer noopener',
                    external: true
                },
                {
                    label: 'Images',
                    url: `/imagemaker/start/history`,
                    target: '_blank',
                    rel: 'noreferrer noopener',
                    external: true
                },
                {
                    label: 'Logos',
                    url: '/logomaker/start/profile/all',
                    target: '_blank',
                    rel: 'noreferrer noopener',
                    external: true
                },
                {
                    label: 'Videos',
                    url: '/videomaker/start/projects',
                    target: '_blank',
                    rel: 'noreferrer noopener',
                    external: true
                },
                {
                    label: 'Designs',
                    url: '/designmaker/start/all-designs',
                    target: '_blank',
                    rel: 'noreferrer noopener',
                    external: true
                }
            ].filter(Boolean)
        },
        {
            label: intl === null || intl === void 0 ? void 0 : intl.formatMessage({ id: 'account', defaultMessage: 'Account' }),
            url: '/user/account',
            children: [
                {
                    label: intl === null || intl === void 0 ? void 0 : intl.formatMessage({
                        id: 'my_plan',
                        defaultMessage: 'My Plan'
                    }),
                    url: '/user/account/my-plan'
                },
                {
                    label: intl === null || intl === void 0 ? void 0 : intl.formatMessage({
                        id: 'account_settings',
                        defaultMessage: 'Account Settings'
                    }),
                    url: '/user/account/settings'
                },
                {
                    label: intl === null || intl === void 0 ? void 0 : intl.formatMessage({
                        id: 'payment_history',
                        defaultMessage: 'Payment History'
                    }),
                    url: '/user/account/history'
                },
                {
                    label: intl === null || intl === void 0 ? void 0 : intl.formatMessage({
                        id: 'assets_usage',
                        defaultMessage: 'Assets Usage'
                    }),
                    url: '/user/account/assets-usage'
                }
            ]
        },
        !isSubFreePlan &&
            isMultiSeat === 1 && {
            label: intl === null || intl === void 0 ? void 0 : intl.formatMessage({ id: 'team', defaultMessage: 'Team' }),
            url: '/user/team',
            children: [
                {
                    label: intl === null || intl === void 0 ? void 0 : intl.formatMessage({
                        id: 'manage_team',
                        defaultMessage: 'Manage Team'
                    }),
                    url: '/user/team/manage'
                },
                {
                    label: intl === null || intl === void 0 ? void 0 : intl.formatMessage({
                        id: 'team_report',
                        defaultMessage: 'Team Report'
                    }),
                    url: '/user/team/team-report'
                }
            ].filter(Boolean)
        }
    ].filter(Boolean);
    const ListItemLink = (props) => (React.createElement(ListItem, Object.assign({ button: true, component: 'a', className: classes.listItem }, props)));
    const initial = isLogin ? user.name.charAt(0).toUpperCase() : '';
    const HeaderContent = isLogin ? (React.createElement(Box, { component: 'div', className: classes.profile, sx: { display: 'flex', alignItems: 'center' } },
        profile ? (React.createElement("img", { width: 48, height: 48, src: profile, alt: 'profile', style: {
                borderRadius: '50%'
            }, onError: (ev) => (ev.target.src =
                'https://assets.designs.ai/images/svg/icon-avatar.svg') })) : user.name ? (React.createElement(Box, { sx: {
                color: 'white',
                width: '48px',
                height: '48px',
                borderRadius: '50%',
                background: '#4519EF',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '24px',
                fontFamily: 'Poppins-Regular'
            } }, initial)) : (React.createElement("img", { width: 48, height: 48, alt: 'profile', style: {
                borderRadius: '50%'
            }, src: 'https://assets.designs.ai/images/svg/icon-avatar.svg' })),
        React.createElement("div", null,
            React.createElement("div", { className: classes.title },
                "Hi, ",
                user.name),
            user.subscription && (React.createElement(Links, { Link: Link, to: '/user/account/my-plan', className: classes.subtitle },
                ((_a = user === null || user === void 0 ? void 0 : user.subscription) === null || _a === void 0 ? void 0 : _a.sub_category) === 'pro' && (React.createElement("img", { width: '24px', height: '24px', alt: 'Designs.ai Pro crown', src: 'https://assets.designs.ai/images/procrown.svg' })), (_b = user.subscription.sub_plan_name) !== null && _b !== void 0 ? _b : ''))))) : (React.createElement(React.Fragment, null,
        React.createElement(Links, { to: '/', Link: Link, style: { lineHeight: 'unset' } },
            React.createElement(ImgWithFallback, { width: 169, height: 44, alt: 'logo', loading: 'lazy', src: 'https://assets.designs.ai/images/dsai-logo/default.png', fallback: 'https://assets.designs.ai/images/dsai-logo/default.png' })),
        React.createElement("span", { className: cx(classes.welcomeBack) }, intl === null || intl === void 0 ? void 0 : intl.formatMessage({
            id: 'welcome_guest',
            defaultMessage: 'Welcome, Guest!'
        })),
        React.createElement(Button, { size: 'small', className: cx(classes.loginLabelBtn), onClick: () => onAction({ action: 'login' }) }, intl === null || intl === void 0 ? void 0 : intl.formatMessage({ id: 'sign_in', defaultMessage: 'Sign in' })),
        React.createElement("span", { className: classes.signUpBtn, onClick: () => onAction({ action: 'signup' }) }, intl === null || intl === void 0 ? void 0 : intl.formatMessage({
            id: 'sign_up',
            defaultMessage: "Don't have an account? Create one now."
        }))));
    if (isCheckoutPage)
        return React.createElement(React.Fragment, null);
    return (React.createElement(Box, { sx: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            height: '-webkit-fill-available'
        } },
        React.createElement(Box, null,
            React.createElement(Box, { sx: {
                    gap: '24px',
                    width: '100%',
                    display: 'flex',
                    padding: '16px 24px',
                    flexDirection: 'column',
                    alignItems: isLogin ? 'flex-start' : 'center'
                } },
                React.createElement(Box, { sx: { width: '100%', display: 'flex', justifyContent: 'flex-end' } },
                    React.createElement(IconButton, { color: 'primary', "aria-label": 'open drawer', edge: 'start', disableRipple: true, onClick: handleDrawerToggle, className: classes.closeIcon },
                        React.createElement(CloseIcon, { fontSize: 'large' }))),
                HeaderContent),
            React.createElement(Divider, { className: classes.divider }),
            isLogin && (React.createElement(React.Fragment, null,
                dashboardWithoutChildren.map((item, key) => (React.createElement(ListItemLink, { key: key, href: item.url },
                    React.createElement(Typography, { style: {
                            fontSize: '16px',
                            fontFamily: 'Poppins-Semibold'
                        } }, item.label)))),
                dashboardMenu.map((items, key) => (React.createElement(Accordion, { key: key, className: classes.accordion, expanded: expanded === items.label, onChange: handleChange(items.label), classes: { expanded: classes.expanded }, onClick: () => handleSelectItem(items.label) },
                    React.createElement(AccordionSummary, { id: 'panel1a-header', "aria-controls": 'panel1a-content', expandIcon: React.createElement(ExpandMoreIcon, null), className: classes.accordionSummary, classes: { expanded: classes.expanded }, sx: {
                            background: selectedItem === items.label
                                ? '#F4F6F8 !important'
                                : 'inherit',
                            '.Mui-expanded': { margin: '0 !important' },
                            '.MuiAccordionSummary-content': { margin: '0 !important' }
                        } },
                        React.createElement(Typography, { sx: {
                                fontSize: '16px',
                                fontFamily: 'Poppins-SemiBold'
                            } }, items.label)),
                    React.createElement(AccordionDetails, { classes: { root: classes.removePadding }, className: classes.accordionDetail }, 'children' in items &&
                        items.children.map((child, key) => (React.createElement(ListItemLink, { key: key, href: child.url },
                            React.createElement(Typography, { style: {
                                    fontSize: '16px',
                                    fontFamily: 'Poppins-Regular'
                                } }, child.label)))))))))),
            defaultMenu.map((labels, key) => (React.createElement(Accordion, { key: key, className: classes.accordion, expanded: expanded === labels.label, onChange: handleChange(labels.label), classes: { expanded: classes.expanded }, onClick: () => handleSelectItem(labels.label) },
                React.createElement(AccordionSummary, { id: 'panel2bh-header', expandIcon: React.createElement(ExpandMoreIcon, null), "aria-controls": 'panel2bh-content', className: classes.accordionSummary, sx: {
                        background: selectedItem === labels.label
                            ? '#F4F6F8 !important'
                            : 'inherit',
                        '.Mui-expanded': { margin: '0 !important' },
                        '.MuiAccordionSummary-content': { margin: '0 !important' }
                    } },
                    React.createElement(Typography, { sx: {
                            fontSize: '16px',
                            fontFamily: 'Poppins-SemiBold'
                        } }, labels.label)),
                React.createElement(AccordionDetails, { classes: { root: classes.removePadding }, className: classes.accordionDetail }, 'children' in labels &&
                    labels.children.map((child, key) => (React.createElement(ListItemLink, { key: key, href: child.url },
                        React.createElement(Typography, { style: {
                                fontSize: '16px',
                                fontFamily: 'Poppins-Regular'
                            } }, child.label)))))))),
            !isLogin ||
                (isLogin && ((_c = user === null || user === void 0 ? void 0 : user.subscription) === null || _c === void 0 ? void 0 : _c.sub_category) === 'free') ? (React.createElement(Links, { to: '/pricing', className: classes.linkButton }, intl === null || intl === void 0 ? void 0 : intl.formatMessage({ id: 'pricing', defaultMessage: 'Pricing' }))) : (''),
            React.createElement(Divider, { className: classes.divider }),
            LANGUAGE_MENU.map((labels, key) => (React.createElement(Accordion, { key: key, className: classes.accordion, expanded: expanded === labels.label, onChange: handleChange(labels.label), classes: { expanded: classes.expanded }, onClick: () => handleSelectItem(labels.label) },
                React.createElement(AccordionSummary, { id: 'panel2bh-header', "aria-controls": 'panel2bh-content', expandIcon: React.createElement(ExpandMoreIcon, null), className: classes.accordionSummary, sx: {
                        background: selectedItem === labels.label
                            ? '#F4F6F8 !important'
                            : 'inherit',
                        '.Mui-expanded': { margin: '0 !important' },
                        '.MuiAccordionSummary-content': { margin: '0 !important' }
                    } },
                    React.createElement(Typography, { sx: {
                            fontSize: '16px',
                            fontFamily: 'Poppins-SemiBold'
                        } }, (intl === null || intl === void 0 ? void 0 : intl.formatMessage({
                        id: 'language',
                        defaultMessage: 'Language'
                    })) +
                        '-' +
                        ((currentLanguageLabel === null || currentLanguageLabel === void 0 ? void 0 : currentLanguageLabel.toUpperCase()) || 'EN'))),
                React.createElement(AccordionDetails, { classes: { root: classes.removePadding }, className: classes.accordionDetail }, 'children' in labels &&
                    labels.children.map((item, index) => (React.createElement(ListItemLink, { key: index, onClick: () => changeLang(item.code) },
                        React.createElement(Typography, { style: {
                                fontSize: '16px',
                                fontFamily: 'Poppins-Regular'
                            } }, item.label)))))))),
            isLogin && (React.createElement("a", { className: classes.linkButton, onClick: () => onAction({ action: 'logout' }) }, intl === null || intl === void 0 ? void 0 : intl.formatMessage({
                id: 'sign_out',
                defaultMessage: 'Sign out'
            })))),
        React.createElement(Box, null,
            React.createElement("div", { className: cx(classes.social) }, SOCIAL_MEDIAS.map((v, i) => (React.createElement("a", { className: classes.social_link, href: v.url, key: i, target: '_blank', rel: 'noreferrer noopener' },
                React.createElement(v.Icon, { className: classes.social_svg }))))),
            React.createElement(Company, { intl: intl }))));
};
export default DrawerContent;
//# sourceMappingURL=DrawerContent.js.map